import React from 'react';
import { useSite } from '../../context/SiteContext';

export default function LogoMarquee() {
  const { data } = useSite();
  const logos = (data.logoMarquee?.items || []).filter(Boolean);
  if (logos.length === 0) return null;
  const loop = [...logos, ...logos];

  return (
    <div className="rounded-xl border border-zinc-900 bg-zinc-950/40 overflow-hidden">
      <div className="px-4 py-2 flex items-center gap-2 border-b border-zinc-900">
        <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--gold)] animate-pulse" />
        <span className="text-zinc-300 text-xs font-bold tracking-wider uppercase">
          {data.logoMarquee?.title || 'Featured Brands'}
        </span>
      </div>
      <div className="relative overflow-hidden py-3">
        <div className="flex items-center marquee-track gap-10">
          {loop.map((item, i) => (
            <div key={i} className="shrink-0 h-10 md:h-12 flex items-center justify-center px-2">
              {item.image ? (
                <img src={item.image} alt={item.label || `logo-${i}`} className="max-h-full max-w-[140px] object-contain opacity-95 hover:opacity-100 hover:scale-105 transition" />
              ) : (
                <span className="font-display text-base md:text-lg text-zinc-200 hover:text-[color:var(--gold)] tracking-[0.12em] font-extrabold whitespace-nowrap transition">
                  {item.label}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
